export default {
	common: {
		appName: "Comms Service",
		signIn: "Entrar",
		signUp: "Cadastrar",
		signOut: "Sair",
		signInRequired: "Login Necessario",
		signInRequiredDescription: "Faca login para acessar o painel.",
		dontHaveAccount: "Nao tem uma conta?",
		loading: "Carregando...",
		save: "Salvar",
		cancel: "Cancelar",
		delete: "Excluir",
		create: "Criar",
		edit: "Editar",
		confirm: "Confirmar",
		search: "Buscar",
		noResults: "Nenhum resultado encontrado",
		creating: "Criando...",
		createSuccess: "Criado com sucesso",
		updating: "Atualizando...",
		updateSuccess: "Atualizado com sucesso",
		deleting: "Excluindo...",
		deleteSuccess: "Excluido com sucesso",
		copied: "Copiado para a area de transferencia",
	},
	nav: {
		dashboard: "Painel",
		messages: "Mensagens",
		organizations: "Organizacoes",
		apiKeys: "Chaves de API",
		senderIdentities: "Identidades de Envio",
		apiDocs: "Docs da API",
		docs: "Documentação",
		settings: "Configuracoes",
	},
	messages: {
		title: "Mensagens",
		noMessages: "Nenhuma mensagem ainda",
		channel: "Canal",
		status: "Status",
		recipient: "Destinatario",
		createdAt: "Criado em",
	},
	organizations: {
		title: "Organizacoes",
		name: "Nome",
		slug: "Slug",
		members: "Membros",
		createNew: "Criar Organizacao",
	},
	apps: {
		title: "Aplicativos",
		createNew: "Criar Aplicativo",
		name: "Nome do Aplicativo",
		noApps: "Nenhum aplicativo ainda",
		createFirst: "Crie seu primeiro aplicativo para comecar.",
		selectApp: "Selecione um aplicativo",
		active: "Ativo",
		inactive: "Inativo",
		manageKeys: "Gerenciar Chaves",
		deleteConfirm: "Excluir este aplicativo? Todas as chaves de API serao removidas.",
		settings: "Configuracoes do Aplicativo",
	},
	apiKeys: {
		title: "Chaves de API",
		name: "Nome",
		key: "Chave de API",
		prefix: "Prefixo da Chave",
		lastUsed: "Ultimo Uso",
		never: "Nunca",
		active: "Ativa",
		inactive: "Inativa",
		createNew: "Criar Chave de API",
		showOnce: "Esta chave sera mostrada apenas uma vez. Copie agora.",
		copyKey: "Copiar Chave",
		revoke: "Revocar",
		revokeConfirm: "Revocar esta chave de API?",
		deleteConfirm: "Excluir permanentemente esta chave de API?",
	},
	senderIdentities: {
		title: "Identidades de Envio",
		createNew: "Adicionar Dominio",
		domain: "Dominio",
		channel: "Canal",
		provider: "Provedor",
		status: "Status",
		identifier: "Identificador",
		dnsRecords: "Registros DNS",
		dnsType: "Tipo",
		dnsName: "Nome",
		dnsValue: "Valor",
		copyValue: "Copiar",
		noIdentities: "Nenhuma identidade de envio ainda",
		createFirst: "Registre um dominio para comecar a enviar mensagens.",
		verifyNow: "Verificar Status",
		verifying: "Verificando...",
		deleteConfirm:
			"Excluir esta identidade de envio? Os registros DNS serao removidos do provedor.",
		statusPending: "Pendente",
		statusSuccess: "Verificado",
		statusFailed: "Falhou",
		statusTemporaryFailure: "Pendente",
		noProviders: "Nenhum provedor disponivel para este canal ainda.",
		addDnsInstructions:
			"Adicione os seguintes registros DNS ao seu dominio para completar a verificacao.",
	},
	apiDocs: {
		title: "Uso da API",
		subtitle: "Envie mensagens programaticamente usando a API REST.",
		baseUrl: "URL Base",
		authentication: "Autenticacao",
		authDescription: "Inclua sua chave de API no header x-api-key em todas as requisicoes.",
		manageKeys: "Gerenciar Chaves de API",
		sendEmail: "Enviar Email",
		endpoint: "Endpoint",
		requestBody: "Corpo da Requisicao",
		response: "Resposta",
		rawContent: "Conteudo Direto",
		templateContent: "Template",
		field: "Campo",
		type: "Tipo",
		required: "Obrigatorio",
		optional: "Opcional",
		description: "Descricao",
		fieldReference: "Referencia de Campos",
		errors: "Respostas de Erro",
		copied: "Copiado!",
		senderFromAddress: "Endereco de email do remetente (deve ser de um dominio verificado)",
		senderFromName: "Nome de exibicao do remetente",
		senderReplyTo: "Endereco de email para resposta",
		destinationTo: "Array de enderecos de email dos destinatarios",
		destinationCc: "Array de enderecos de email CC",
		destinationBcc: "Array de enderecos de email CCO",
		contentType: 'Tipo de conteudo: "raw" ou "template"',
		contentSubject: "Assunto do email (apenas raw)",
		contentBody: "Corpo do email em HTML (apenas raw)",
		contentTemplateId: "Identificador do template (apenas template)",
		contentTemplateParams: "Pares chave-valor para variaveis do template (apenas template)",
		metadata: "Metadados chave-valor anexados a mensagem",
		status202: "Mensagem aceita para processamento",
		status400: "Validacao falhou — verifique o corpo da requisicao",
		status401: "Chave de API ausente ou invalida",
	},
	settings: {
		title: "Configuracoes",
		language: "Idioma",
		theme: "Tema",
		profile: "Perfil",
	},
	billing: {
		eyebrow: "Cobranca",
		title: "Cobranca e Creditos",
		balance: "Saldo de Creditos",
		purchased: "Comprado",
		consumed: "Consumido",
		refunded: "Reembolsado",
		feesCharged: "Taxas cobradas",
		usageThisPeriod: "Uso Neste Periodo",
		emailUsage: "E-mails (plano gratuito)",
		whatsappUsage: "WhatsApp",
		comingSoon: "Em breve",
		buyCredits: "Comprar Creditos",
		amountUsd: "Valor (USD)",
		checkout: "Pagar",
		checkoutError: "Nao foi possivel iniciar o pagamento. Tente novamente.",
		managePortal: "Gerenciar Cobranca",
		syncing: "Finalizando sua compra…",
	},
	org: {
		selectTitle: "Selecionar Organizacao",
		selectSubtitle: "Escolha uma organizacao para continuar",
		switchOrganization: "Trocar Organizacao",
		noOrganizations: "Nenhuma organizacao ainda",
		createFirst: "Crie sua primeira organizacao para comecar.",
		createNew: "Criar Organizacao",
		name: "Nome da Organizacao",
		slug: "Slug",
	},
	errors: {
		api: {
			INTERNAL_ERROR: "Ocorreu um erro inesperado",
			NOT_FOUND: "Recurso nao encontrado",
			UNAUTHORIZED: "Faca login novamente",
			PERMISSION_DENIED: "Voce nao tem permissao para esta acao",
			VALIDATION_ERROR: "Falha na validacao",
			PARSE_ERROR: "Nao foi possivel processar a requisicao",
			ORG_REQUIRED: "Organizacao e obrigatoria",
			CONFLICT: "Um recurso com esse identificador ja existe",
		},
	},
};
